import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Button } from '@lightspeed/flame/Button';
import { IconVerified } from '@lightspeed/flame/Icon/Verified';
import { Spinner } from '@lightspeed/flame/Spinner';

import axios from 'axios';
import { BusyActionState, CompletedActionState } from './utils';

class CayanActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isTesting: false,
      isTestingSuccess: false,
      savedTerminalName: '',
      savedTerminalAddress: '',
    };

    this.testTerminal = this.testTerminal.bind(this);
  }

  testTerminal() {
    const { terminalAddress, terminalName, onTestingError } = this.props;

    this.setState({ isTesting: true }, () => {
      onTestingError(null);
      axios
        .get(`https://${terminalAddress}:8443/v2/pos?Action=Status&Format=JSON`)
        .then(() => {
          this.setState({
            isTesting: false,
            isTestingSuccess: true,
            savedTerminalName: terminalName,
            savedTerminalAddress: terminalAddress,
          });
        })
        .catch(err => {
          this.setState({ isTesting: false });
          onTestingError(err.message);
        });
    });
  }

  render() {
    const { terminalAddress, terminalName, isValid } = this.props;
    const { isTesting, savedTerminalName, savedTerminalAddress } = this.state;
    let { isTestingSuccess } = this.state;

    if (
      (savedTerminalName && savedTerminalName !== terminalName) ||
      (savedTerminalAddress && savedTerminalAddress !== terminalAddress)
    ) {
      isTestingSuccess = false;
    }

    return (
      <div className="cr-flex cr-flex-col cr-width-full">
        {!isTestingSuccess && !isTesting && (
          <Button
            onClick={this.testTerminal}
            loading={isTesting}
            disabled={!isValid}
            variant="secondary"
            fill
          >
            Test terminal connection
          </Button>
        )}
        {!isTestingSuccess && isTesting && (
          <div className="cr-flex cr-items-center cr-justify-center cr-radius-1 cr-border-blue cr-border-style-solid cr-border-width-1 cr-p-1">
            <Spinner color="blue" />
            <BusyActionState>Trying to connect to terminal...</BusyActionState>
          </div>
        )}
        {isTestingSuccess && (
          <div className="cr-flex cr-items-center cr-justify-center cr-radius-1 cr-border-green cr-border-style-solid cr-border-width-1 cr-p-1">
            <IconVerified baseColor="green" />
            <CompletedActionState>{`Connection to '${terminalName}' successful`}</CompletedActionState>
          </div>
        )}
      </div>
    );
  }
}

CayanActions.propTypes = {
  onTestingError: PropTypes.func,
  isValid: PropTypes.bool,
  terminalAddress: PropTypes.string,
  terminalName: PropTypes.string,
};

CayanActions.defaultTypes = {
  onTestingError: () => {},
  isValid: false,
  terminalAddress: '',
  terminalName: '',
};

export default CayanActions;
